import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../../shared/_services/user.service';

import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../../shared/_services/authentication.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['../login.component.css'],
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm: FormGroup;
  passvalid: boolean = true;
  error = '';

  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private _userService: UserService,
              private authenticationService: AuthenticationService) { }

  // convenience getter for easy access to form fields
  get f() { return this.changePasswordForm.controls; }

  ngOnInit() {
    this.changePasswordForm = this.formBuilder.group({
      newPassword: ['', Validators.required],
      confirmNewPassword: ['', Validators.required]
    }); 
  }

  onSubmit() {
    if (this.changePasswordForm.invalid) {
      return;
    }

    this._userService.setNewPassword(this.f.confirmNewPassword.value).pipe(first())
      .subscribe(data => {
        let user = data;
        localStorage.clear;
        this.authenticationService.setCurrentUser(user);
        this.router.navigate(['/']);
      },
        error => {
          this.error = error;
        });
  }

  onBlurMethod() {
    //valida contraseñas iguales
    if (this.f.newPassword.value == this.f.confirmNewPassword.value) {
      this.passvalid = true;
    } else {
      this.passvalid = false;
      this.f.confirmNewPassword.setValue('');
    }
  }

}
